import { render, staticRenderFns } from "./positionController.vue?vue&type=template&id=06cfe7c0&"
import script from "./positionController.vue?vue&type=script&lang=ts&"
export * from "./positionController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports